import React from 'react'
import Iframe from 'react-iframe'
import config from '../../config.json';

const VaccineFaqs = () => {
  console.log(config.vaccine_faq);
  return (
    <Iframe url={`${config.vaccine_faq}&output=embed`}
      width="100%"
      height="100%"
      id="myId"
      style={{ padding: "1rem", margin: "auto", width: "100%", height: "100%" }}
      display="initial"
      position="relative"
      allowFullScreen />
  )
}
export default VaccineFaqs;